module.exports = __webpack_public_path__ + "img/boohgle_auth_print_image_jp.7248ec6e.jpg";